export default [
	{
		path: '/site_pages/:id/editor/:lang',
		lazy: async () => {
			const Module = await import('../../../../pages/services/admin/SitePageEditor/SitePageEditorPage');
			return { Component: Module.default };
		},
	},
];
